import { createReducer } from '@reduxjs/toolkit'
import { resetModalConfirm, setModalConfirmVisible, showModalConfirm } from './modal-confirm.actions'

export type ModalConfirmFields = {
  payload?: any
  url: string
  reference: string | number
}

export interface ModalConfirmState {
  isVisible: boolean
  data: ModalConfirmFields | null
}

const initialState: ModalConfirmState = {
  isVisible: false,
  data: null
}

export const modalConfirmReducer = createReducer(initialState, builder => {
  builder
    .addCase(setModalConfirmVisible, (state, action) => {
      state.isVisible = action.payload
    })
    .addCase(showModalConfirm, (state, action) => {
      state.data = null
      state.data = action.payload
      state.isVisible = true
    })
    .addCase(resetModalConfirm, state => {
      state.isVisible = false
    })
})
